export enum ADDONS {
  WHATSAPP = 'whatsapp',
  LIVE_CALLS_TRANSCRIPTION = 'live calls transcription',
  CALLS_RECORDING_TRANSCRIPTION = 'calls recording transcription',
  VOICEMAIL_TRANSCRIPTION = 'voicemail transcription',
  ANALYTICS = 'analytics',
  BROADCAST = 'broadcast',
}
